import React from 'react';
import Resources from '../domains/resources/components/Resources';

const ResourcesPage: React.FC = () => {
  return <Resources />;
};

export default ResourcesPage;
